

export default {
  name: "hubspot",
  props: {
    content: Object
  },
  mounted(){

    let vm = this; 
    window.hbspt.forms.create({
      region: vm.content.region,
      portalId: vm.content.portalid,
      formId: vm.content.formid,
      target: '#embedded-form'
    })

  }


}

